import { IBrowserIconsConstantsForOs, IBrowserIconsConstantsRect, IBrowserIconsConstantsSizes, IBrowserIconsConstantsText } from '../interfaces';

const CONSTANTS_ICON: IBrowserIconsConstantsSizes = { browserIconsSizes: [128], iconsPaddingBase: 12.5 };
const CONSTANTS_RECT: IBrowserIconsConstantsRect = { borderRadiusBase: 23 };
const CONSTANTS_TEXT: IBrowserIconsConstantsText = { textMaxWidthBase: 77.25, textFontSizeBase: 43.5, lineHeightRatio: 0.87356 };

export const BROWSER_ICONS_CONSTANTS_FOR_MAC: IBrowserIconsConstantsForOs = { ...CONSTANTS_ICON, ...CONSTANTS_RECT, ...CONSTANTS_TEXT };
